import { c as _c } from "react-compiler-runtime";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/core/utils";
const cardVariants = cva("text-card-foreground border", {
  variants: {
    tone: {
      default: "bg-card border-border/60",
      warm: "bg-card border-primary/15",
      muted: "bg-muted/40 border-border/50",
      white: "border-border/60 bg-white"
    },
    size: {
      sm: "p-4",
      md: "p-6",
      lg: "p-8"
    },
    radius: {
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg"
    }
  },
  defaultVariants: {
    tone: "default",
    size: "md",
    radius: "md"
  }
});
export interface CardProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof cardVariants> {}
export function Card(t0) {
  const $ = _c(14);
  let className;
  let props;
  let radius;
  let size;
  let tone;
  if ($[0] !== t0) {
    ({
      className,
      tone,
      size,
      radius,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = radius;
    $[4] = size;
    $[5] = tone;
  } else {
    className = $[1];
    props = $[2];
    radius = $[3];
    size = $[4];
    tone = $[5];
  }
  let t1;
  if ($[6] !== className || $[7] !== radius || $[8] !== size || $[9] !== tone) {
    t1 = cn(cardVariants({
      tone,
      size,
      radius,
      className
    }));
    $[6] = className;
    $[7] = radius;
    $[8] = size;
    $[9] = tone;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== props || $[12] !== t1) {
    t2 = <div className={t1} {...props} />;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export function CardHeader(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("space-y-1.5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function CardBody(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("space-y-2", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function CardFooter(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("pt-2", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}